import React from "react";
import { useParams } from "react-router-dom";
import PnoeTestDetailsView from "../orders/PnoeTestDetailsView";
import HistoryNotReadyState from "./HistoryNotReadyState";
import useHistoryScope from "./useHistoryScope";
import { useAuth } from "../../../../providers/AuthProvider";

/**
 * `…/assessments/pnoe/:measurementId` — one PNOĒ breath test's detail.
 *
 * `PnoeTestDetailsView` fetches and polls its own data from the measurement id,
 * so this route only supplies the id. The way back to the tab is the
 * breadcrumb's, derived from the URL (`useBackNavigation`).
 */
const PnoeTestDetailRoute = () => {
  const { measurementId } = useParams();
  const { kind } = useHistoryScope();
  const { AuthIsSimpleUser } = useAuth();

  if (!measurementId) {
    return (
      <HistoryNotReadyState
        title="Test not found"
        text="This breath test is no longer available. Go back to Assessments to see the current list."
      />
    );
  }

  return (
    <div style={styles.root}>
      <PnoeTestDetailsView
        measurementId={measurementId}
        // Only the cross-client page needs the badge; the workspace shells
        // already name the subject in their top bar.
        showClientBadge={kind === "company"}
        // A customer only reads their test: no edits, status menu or export.
        readOnly={AuthIsSimpleUser}
      />
    </div>
  );
};

export default PnoeTestDetailRoute;

const styles = {
  root: {
    width: "100%",
    flex: 1,
    minHeight: 0,
    display: "flex",
    flexDirection: "column" as "column",
    boxSizing: "border-box" as "border-box",
  },
};
